const stripNonAlpha = (s: string) => s.replace(/[^a-zA-Z\s]+/g, "");
const stripMultiSpaces = (s: string) => s.replace(/\s\s+/g, " ");
const stripOuterSpaces = (s: string) => s.trim();
const stripLinks = (s: string) => s.replace(/https?.*?(?= |$)/g, "");

export const cleanText = (s: string) => stripOuterSpaces(stripMultiSpaces(stripNonAlpha(stripLinks(s))));
